import { Injectable } from '@angular/core';
import { IesHttpClient } from '../../Common/ies-http-client.service';
import { AppUrl } from './../../Common/appUrl';


@Injectable()
export class AdmManageProctorTeamLeadService {
  private officeData: any;
  private groupData: any;
  private proctorLeadData: any;
  private proctorData :any;
  constructor(private _httpClient: IesHttpClient) {
  }

  // TODO : Need to update urls Name after changes in APIs side

  getData(params: any) {
    return this._httpClient.get(AppUrl.getProctorDetail, params);
  }

  getProctorNames(param: string) {
    return this._httpClient.get(AppUrl.getProctorNames, param);
  }

  getGroups() {
    return this._httpClient.get(AppUrl.getProctorGroups);
  }

  getOffice() {
    return this._httpClient.get(AppUrl.getOfficeDetail);
  }

   set groupList(data: any) {
    this.groupData = data;
  }
  get groupList(): any {
    return this.groupData;
  }

  set proctorLeadList(data: any) {
    this.proctorLeadData = data;
  }
  get proctorLeadList(): any {
    return this.proctorLeadData;
  }
 set proctorList(data: any) {
    this.proctorData = data;
  }
  get proctorList(): any {
    return this.proctorData;
  }

}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.service.ts